import { IAccessor, ICreateAccessorPayload, IUpdateAccessorPayload } from 'interfaces';
import { axiosPrivate } from 'services/axios';
import { BaseService } from './BaseService';

class AccessorService extends BaseService<IAccessor> {
  constructor() {
    super('accessories');
  }
  canDelete = true;
  canBulkDelete = true;

  /**
   * Create accessor with explicit payload typing.
   * Uses explicit request to avoid BaseService swallowed errors.
   */
  create = async (payload: ICreateAccessorPayload) => {
    const res = await axiosPrivate.post(`${this.modulePrefix}/`, payload);
    return res.data;
  };

  /**
   * Update accessor with explicit payload typing.
   * Uses explicit request to avoid BaseService swallowed errors.
   */
  updateAccessor = async (id: number, payload: IUpdateAccessorPayload) => {
    const res = await axiosPrivate.patch(`${this.modulePrefix}/${id}/`, payload);
    return res.data;
  };

  /**
   * Domain-specific alias for equipment switch.
   */
  switchEquipment = async (id: number, equipmentId: number) =>
    this.updateAccessor(id, { equipment: equipmentId });
}

export const accessorService = new AccessorService();
